import { Button, Caption1, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';

/**
 * THE LINE THAT SAYS OFFICE STAFF ARE HIDDEN (Julio, 2026-10-21, #804: "by default admin non clincial titles are hidden filtered out
 * from the roster list"). Staff whose job titles are all administrative or office are left out of the Roster's list, the map's
 * side list and the map, and this line says how many, with the way to show them. Shown, it offers the way back. Nothing is drawn
 * while nobody on the roster holds only such titles. Held for this visit only: it is not a filter, and nothing remembers it.
 */
const useStyles = makeStyles({
  line: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap: tokens.spacingHorizontalS, rowGap: tokens.spacingVerticalXXS },
});

export const OFFICE_HIDDEN_WORDS = (count: number): string => `${count} office and administrative ${count === 1 ? 'staff member is' : 'staff are'} hidden.`;
export const OFFICE_SHOWN_WORDS = 'Office and administrative staff are shown.';

export function OfficeStaffLine({ count, shown, onShown }: {
  /** How many people on the roster hold only non-clinical job titles. */
  readonly count: number;
  readonly shown: boolean;
  readonly onShown: (shown: boolean) => void;
}) {
  const styles = useStyles();
  if (count === 0) return null;
  return (
    <section className={styles.line} aria-label="Office staff">
      <Caption1>{shown ? OFFICE_SHOWN_WORDS : OFFICE_HIDDEN_WORDS(count)}</Caption1>
      <Button appearance="transparent" size="small" onClick={() => onShown(!shown)}>{shown ? 'Hide them' : 'Show them'}</Button>
    </section>
  );
}
